import { defineStore } from 'pinia'

import { Category } from '@/common/models/data/dashboard/posts/category'
import CategoriesRepository from '@/app/repositories/categories-repository'

const useCategoriesStore = defineStore('categories', {
    state: () => ({
        categories: [] as Array<Category>
    }),
    actions: {
        async load (): Promise<void> {
            this.categories = await CategoriesRepository.all()
        }
    },
    getters: {
        mainMenuCategories: (state) => {
            return state.categories.filter(category => category.main_menu)
        },
        bySlug: (state) => {
            return (slug: string): Category | undefined => {
                return state.categories.find(category => {
                    return category.slug === slug
                })
            }
        }
    }
})

export {
    useCategoriesStore
}
